import { render, staticRenderFns } from "./distcommissionpool-add-or-update.vue?vue&type=template&id=2c41c000&"
import script from "./distcommissionpool-add-or-update.vue?vue&type=script&lang=js&"
export * from "./distcommissionpool-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports